var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 5.96575V5.7845C0 3.60012 1.57875 1.737 3.73125 1.37825C5.12813 1.14106 6.60625 1.60543 7.625 2.62575L8 3.00012L8.34688 2.62575C9.39375 1.60543 10.8438 1.14106 12.2688 1.37825C14.4219 1.737 16 3.60012 16 5.7845V5.96575C16 7.26262 15.4625 8.50325 14.5125 9.38762L8.86563 14.6595C8.63125 14.8782 8.32187 15.0001 8 15.0001C7.67812 15.0001 7.36875 14.8782 7.13438 14.6595L1.48719 9.38762C0.538437 8.50325 9.375e-06 7.26262 9.375e-06 5.96575H0Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.3e16c447b0ba6496a19c9dc80daf42f4.svg";
export { ForwardRef as ReactComponent };